import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import {Table} from 'react-bootstrap';
import SvgIcon from 'react-icons-kit';
import {bin} from 'react-icons-kit/icomoon/bin';
import {floppyDisk} from 'react-icons-kit/icomoon/floppyDisk'
import Help from '../../generics/help';

var Config = require('../../../config');

class ModifyFractioning extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.searchComponent = this.searchComponent.bind(this);
		this.changeVolume = this.changeVolume.bind(this);
		this.updateVolume = this.updateVolume.bind(this);
		this.deleteUnit = this.deleteUnit.bind(this);
		this.search = this.search.bind(this);

		this.state = {
			unit_number:"",
			isLoading:false,
			component:[],
			list_table:[],
			columns:[],
		}
	}

	componentDidMount(){
		this.props.waiting.handleShow('Cargando...');
		setTimeout(()=>{
			this.props.waiting.handleClose();
		}, 300)
		fetch(Config.default.apiGateway.URL+'list_show?option=list_key&search=MODIFY_UNIT',{ 
	        method: 'get',
	        headers: new Headers({
	           'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
	           'Accept': 'application/json',
	            'Content-Type': 'application/json',
	        })
      	})
      	.then(response => {
      		if(response.ok){
      			return response.json();
      		}else{
      			response.text().then((msg)=>{
      				swal('Error', msg, 'error');
      			});
      		}   		
      	}).then(response => {
        	if(response !== undefined){

          		this.setState({ columns: response });
        	}
      	});
	}

	showColumn(column_name){
      	for(var i =0; i < this.state.columns.length;i++){
  			if(this.state.columns[i]=== column_name){
          		return false;
        	}
      	}

	    return true;
  	}

	handleChange(e){
		this.setState({
			[e.target.name]: e.target.value
		});
	}

	searchComponent(e){
		//
		if(e.key === 'Enter'){
			e.preventDefault();
			this.search();
		}else{
			this.handleChange(e);
		}
	}

	search(){
		if(this.state.unit_number !== ""){
			this.props.waiting.handleShow('Cargando...');
			fetch(Config.default.apiGateway.URL+'units/actives_by_number?unit_number='+this.state.unit_number+
				'&health_facilities_id='+sessionStorage.getItem('health_facilities_id'),{
				method : 'GET',
				headers: new Headers({
					'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
					'Accept'		: 'application/json',
					'Content-Type'	: 'application/json'
				})
			})
			.then(res => {
				this.props.waiting.handleClose();
				if(res.ok){
					return res.json()
				}
				else{
					this.setState({
						component:[]
					});

					res.text().then(function(result){
						swal(result, "",'warning');
					})
					
				}					
			})
			.then(response => {
				if(response !== undefined ){
					this.setState({
						component:response
					});

				}
			});
		}else{
			swal('Error', 'Debe ingresar un numero de unidad.', 'error');
		}	
	}

	changeVolume(e){
		var id = parseInt(e.target.id, 10);
		var index = this.state.component.findIndex(obj => obj.id === id);
		if(e.target.value.trim() === ''){
			this.state.component[index].volume = parseInt(e.target.value, 10);
		}

		if(e.target.value.length < 4){
			if(e.target.value.indexOf('-') === -1){
				this.state.component[index].volume = parseInt(e.target.value, 10);
			}
			
		}
		
		this.forceUpdate();
	}

	updateVolume(e, i){
		var id = this.state.component[i].id;
		var obj = {
			id:id,
			volume:this.state.component[i].volume
		};

		this.props.waiting.handleShow('Actualizando...');
		fetch(Config.default.apiGateway.URL+'units/update_volume?unit_id='+id, {
			method:'POST',
			body: JSON.stringify(obj),
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){

			}
		})
	}

	deleteUnit(e, i){
		var id = this.state.component[i].id;
		var unit = this.state.component[i].unit_number;


		swal({
	        title: '¿Está seguro?',
	        text: '¿Desea eliminar la unidad?',
	        type: 'warning',
	        showCancelButton: true,
	        confirmButtonColor: '#DD6B55',
	        confirmButtonText: '¡Si, Eliminar!',
	        cancelButtonText: '¡No, Cancelar!',
	        closeOnConfirm: true,
	        closeOnCancel: true
	    }, function (isConfirm) {
	        if (isConfirm) {

	          	this.props.waiting.handleShow('Eliminando...');
				fetch(Config.default.apiGateway.URL+'units/'+id, {
					method:'DELETE',
					headers: new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					this.props.waiting.handleClose();
					if(res.ok){
						return res.json();
					}else{
						res.text().then((msg)=>{
							swal('Error', msg, 'error');
						});
					}
				}).then(response => {
					if(response !== undefined){
						this.setState({unit_number:unit});
						this.search();
					}
				})
	        }
	    }.bind(this));				
	}

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{sessionStorage.getItem('health_facilities_name')} ->
						{t('sidebar.nav.home.MAIN')} -> 
						{t('sidebar.nav.process.MAIN')} ->
						{t('sidebar.nav.process.unit_modify.MAIN')}
					</h5>
				</div>
				<Help 
					{...this.props}
	                menu={"help_processed"} 
	                submenu={"help_change_division"}  />
				<form noValidate>
					<div className="col-xs-12 form-group">

						<div className="col-xs-12 col-sm-2">
							<span className="span-min">Número de Unidad</span>
							<input type="text" name="unit_number" id="unit_number"  
								value={this.state.unit_number || ""} 
								onKeyPress={this.searchComponent}
								onChange={this.handleChange} className="form-control" />
						</div>					

						<div className="col-xs-12 col-sm-2" style={{marginTop:"16px"}}>
							<button type="button" className="btn btn-info" onClick={this.search} >
		                      Buscar
		                    </button> 
						</div>
						
					</div>	



					<hr style={{width:"100%"}}/>

					<div className="col-xs-12 col-sm-8 col-sm-offset-2 form-group">
						<Table responsive hover>
							<thead>
								<tr>
									<th hidden={this.showColumn('UNIT_NUMBER')}>Unidad</th>
									<th hidden={this.showColumn('COMPONENT_NUMBER')}>No. Componente</th>
									<th hidden={this.showColumn('VOLUME')} style={{width:"15%"}}>Volumen</th>
									<th hidden={this.showColumn('CONTROLS')} style={{width:"10%"}}></th>
									<th hidden={this.showColumn('CONTROLS')} style={{width:"10%"}}></th>
								</tr>
							</thead>
							<tbody>
								{this.state.component.map((c, i)=>{
									return <tr key={i}>
										<td hidden={this.showColumn('UNIT_NUMBER')}>{c.unit_number}</td>
										<td hidden={this.showColumn('COMPONENT_NUMBER')}>{c.code+' '+c.component_number}</td>
										<td hidden={this.showColumn('VOLUME')}>
											<input type="number" value={c.volume} 
												className="form-control" 
												id={c.id}
												onChange={this.changeVolume} />
										</td>
										<td hidden={this.showColumn('CONTROLS')}>
											<button type="button" className="btn btn-info btn-xs"
												title="Guardar" mini={true} style={{marginLeft:"5px"}} 
												onClick={(e) => this.updateVolume(e, i)}>
												<SvgIcon icon={floppyDisk}/>
						                    </button>
										</td>
										<td hidden={this.showColumn('CONTROLS')}>
											<button type="button" className="btn btn-info btn-xs"
												title="Eliminar" mini={true} style={{marginLeft:"5px"}} 
												onClick={(e) => this.deleteUnit(e, i)}
												disabled={!c.can_delete}>
												<SvgIcon icon={bin}/>
						                    </button>
										</td>
									</tr>
								})}
									
							</tbody>
						</Table>
					</div>
				</form>
			</div>
		)
	}

}

export default translate('translations')(ModifyFractioning);